import React, { useEffect } from "react";
import { bool, func } from "prop-types";
import { HideBalance, Text } from "@ui-kit/components/index.es";
import { compose } from "redux";
import { connect } from "react-redux";
import { go, goBack } from "react-router-redux";

import Head from "pages/_components/Head";
import { resizableRoute } from "pages/_components/Resizable";

import { actions as layoutActions } from "reducers/layout";
import { actions as settingsActions, selectors as settingsSelectors } from "reducers/settings";

import * as i18n from "util/i18n";
import * as config from "util/config";
import { getPostLoginHomePath } from "util/v3UxConfig";

function HideBalancePage({ dispatch, hideAmount, isDesktop, embeddedInV3Shell = false }) {
    const enableHideAmounts = config.getBoolean("frontend.hide.accounts.balance.funcionalities", false);

    useEffect(() => {
        if (!enableHideAmounts || isDesktop) {
            dispatch(go(getPostLoginHomePath(embeddedInV3Shell)));
        }
        if (embeddedInV3Shell) {
            dispatch(layoutActions.setScopes(["settings"]));
            dispatch(layoutActions.setTitleKey("settings.mobile.hidebalance"));
            dispatch(layoutActions.setGoBackPath("/settings"));
            dispatch(layoutActions.setRightContentMobile(null));
        }
        return () => {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        };
    }, [dispatch, enableHideAmounts, isDesktop, embeddedInV3Shell]);

    return (
        <>
            {!embeddedInV3Shell && (
                <Head
                    onBack={() => dispatch(goBack())}
                    headerClassName="blue-main-header-mobile"
                    centerElement={() => (
                        <Text as="subtitle" color="text-inverse">
                            {i18n.get("settings.mobile.hidebalance")}
                        </Text>
                    )}
                    accessibilityTextId="settings.mobile.hidebalance"
                />
            )}
            <HideBalance
                headText={i18n.get("settings.mobile.hidebalance.headText")}
                label={i18n.get("settings.mobile.hidebalance")}
                updateHideBalance={(hide) => dispatch(settingsActions.updateHideBalance(hide))}
                currentHideBalanceValue={hideAmount}
            />
        </>
    );
}

HideBalancePage.propTypes = {
    dispatch: func.isRequired,
    hideAmount: bool.isRequired,
    isDesktop: bool.isRequired,
    embeddedInV3Shell: bool,
};

HideBalancePage.defaultProps = {
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    hideAmount: Boolean(settingsSelectors.getUserData(state)?.hideBalance),
});

export default compose(connect(mapStateToProps), resizableRoute)(HideBalancePage);
